<template>
  <b-modal
    :id="refModal"
    :ref="refModal"
    title="Import Hàng Loạt Chương Trình Voucher"
    size="xl"
    hide-footer
  >
    <b-row>
      <b-col>
        <div class="form-group">
          <span>
            <b>Bước 1:</b> Tải file Excel mẫu
            <a href="javascript:void(0)" @click="downloadTemplate">tại đây</a>
            và điền dữ liệu đúng cấu trúc. Mỗi dòng là một chương trình voucher.
          </span>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <span><b>Bước 2:</b> Chọn file đã điền và tải lên để kiểm tra</span>
        <UploadFileMulter
          v-on:send-file="onPreview"
          v-on:clear-file="onClear"
          :cmdUrl="'v2/vouchers/import-campaign-excel'"
        />
        <span v-if="fileName">Tên file: <b>{{ fileName }}</b></span>
      </b-col>
    </b-row>

    <b-container class="mt-4 pl-0 pr-0" v-show="preview.dataset.length">
      <h5>
        Kết quả kiểm tra ({{ preview.count }} chương trình)
        <b-badge :variant="preview.isValid ? 'success' : 'danger'">
          {{ preview.isValid ? 'Hợp lệ' : 'Có lỗi' }}
        </b-badge>
      </h5>
      <b-table
        responsive
        bordered
        hover
        small
        :fields="fields"
        :items="preview.dataset"
        class="campaign-table"
      >
        <template v-slot:cell(status)="row">
          <b-badge :variant="row.item.isValid ? 'success' : 'danger'">
            {{ row.item.isValid ? 'Hợp lệ' : 'Lỗi' }}
          </b-badge>
        </template>
        <template v-slot:cell(errors)="row">
          <div class="errors" v-if="row.item.errors.length">
            <p class="mb-0 text-danger" v-for="(error, index) in row.item.errors" :key="index">
              {{ error }}
            </p>
          </div>
        </template>
      </b-table>
    </b-container>

    <div class="footer">
      <b-button
        :disabled="!preview.isValid || !preview.dataset.length || isSaving"
        variant="primary"
        size="sm"
        @click="confirmImport"
      >
        Xác nhận Import
      </b-button>
      <b-button class="ml-4" variant="secondary" size="sm" @click="$bvModal.hide(refModal)">
        Hủy
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import UploadFileMulter from '@/view/modules/upload/UploadFileMulter';
import ApiService from '@/core/services/api.service';
import { makeToastSuccess, makeToastFaile } from '@/utils/common';

const emptyPreview = () => ({ count: 0, isValid: false, dataset: [] });

export default {
  components: { UploadFileMulter },
  data() {
    return {
      refModal: 'import-campaign-voucher',
      fileName: '',
      isSaving: false,
      preview: emptyPreview(),
      fields: [
        { key: 'stt', label: 'STT', thStyle: { fontWeight: 600, width: '8%' } },
        { key: 'name', label: 'Tên chương trình', thStyle: { fontWeight: 600, width: '40%' } },
        { key: 'status', label: 'Trạng thái', thStyle: { fontWeight: 600, width: '15%' } },
        { key: 'errors', label: 'Lỗi', thStyle: { fontWeight: 600, width: '37%' } },
      ],
    };
  },
  methods: {
    async downloadTemplate() {
      try {
        const response = await ApiService.query('v2/vouchers/import-campaign-template', {
          responseType: 'blob',
        });
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Mau_Import_Voucher.xlsx';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        makeToastFaile('Không tải được file mẫu');
      }
    },
    onPreview(data, fileName) {
      this.fileName = fileName;
      this.preview = data && data.dataset ? { ...emptyPreview(), ...data } : emptyPreview();
    },
    onClear() {
      this.preview = emptyPreview();
      this.fileName = '';
    },
    async confirmImport() {
      if (this.isSaving) {
        return;
      }
      this.isSaving = true;
      try {
        const response = await ApiService.post('v2/vouchers/confirm-import-campaign', {
          fileName: this.fileName,
          campaigns: this.preview.dataset,
        });
        makeToastSuccess(response.data.message || 'Import thành công');
        this.$emit('imported');
        this.onClear();
        this.$bvModal.hide(this.refModal);
      } catch (error) {
        const message =
          error.response && error.response.data
            ? error.response.data.message
            : 'Import thất bại, vui lòng thử lại';
        makeToastFaile(message);
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  margin-top: 20px;
}
.campaign-table {
  max-height: 420px;
  overflow-y: auto;
}
</style>
